import React from 'react';
import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import EDIconButton from '../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { ChartType } from '../../../../Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Queries/EkonomiskAnalysChartQuery/EkonomiskAnalysChartQuery';
import { Link } from 'react-router';
import { IconType } from '../../../../../BaseComponents/Icon/Utils/IconDefinitions';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

interface IProps {
  type: ChartType;
  title?: string;
  subtitle?: string;
  link?: string;
  children?: React.ReactNode;
}

interface IGraphInfo {
  iconType: IconType;
  minWidth?: number;
  height?: string;
  flex?: boolean;
}

class GraphPanel extends React.PureComponent<IProps> {
  getGraphInfo(chartType: ChartType): IGraphInfo {
    switch (chartType) {
      case 'column':
        return { iconType: 'bar_chart', minWidth: 400, height: '100%' };
      case 'pie':
        return {
          iconType: 'pie_chart',
          flex: true,
        };
      case 'line':
      default:
        return { iconType: 'bar_chart', minWidth: 400, height: '100%' };
    }
  }

  render() {
    const graphInfo: IGraphInfo = this.getGraphInfo(this.props.type);
    return (
      <EDPanel
        title={this.props.title}
        subtitle={this.props.subtitle}
        minWidth={graphInfo.minWidth}
        height={graphInfo.height}
        headerPadding="normal"
        flex={graphInfo.flex}
        avatar={
          <EDIcon color="action" iconType={graphInfo.iconType} size="large" />
        }
        titleAction={
          this.props.link ? (
            <Link to={this.props.link} style={{ textDecoration: 'none' }}>
              <EDIconButton
                tooltip="Gå till analys"
                icon="exit_to_app"
                margin="none"
              />
            </Link>
          ) : (
            <EDIconButton
              tooltip="Gå till analys"
              icon="exit_to_app"
              margin="none"
            />
          )
        }
      >
        {this.props.children ? this.props.children : <EDAvenyProgress />}
      </EDPanel>
    );
  }
}

export default GraphPanel;
